// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import AppLogoImg from '../../components/Utils/AppLogoImg';
import Loader from '../../components/Utils/Loader';

var initialConfigCommonJS = require("../../js/initialConfigCommon.js");
var dashboardCommonJS = require("../../js/dashboardCommon.js");

const ListDevicesApps = (appsParam) => {

  useEffect(() => {    
    console.log("Listado de aplicaciones configuradas cargado correctamente.")        
    initialConfigCommonJS.CargarCuentasAplicacionesRegistradas(appsParam.setDevicesApps) 
  },[appsParam.setDevicesApps]);

  function consultarDispositivosAplicacion(aplicacion){       
    initialConfigCommonJS.operarMenuLateral("abrir")        
    appsParam.setAppToConsult(aplicacion)
    initialConfigCommonJS.cargarListaDispositivos(aplicacion, appsParam.setDevicesList)        
    initialConfigCommonJS.navegarFlujoAplicacionesDispositivos("listadoDispositivosDisponibles","noUpdate")
    document.getElementById("botonAtrasDispositivosDisponibles").style = "display: none"
    document.getElementById("tituloDispositivosDisponibles").innerHTML = "Dispositivos disponibles"    
  }

  function añadirAplicacion(){
    initialConfigCommonJS.operarMenuLateral("abrir")        
    initialConfigCommonJS.navegarFlujoAplicacionesDispositivos("listadoAplicacionesDisponibles","noUpdate")    
  }

  const AppsList = (componentParam) => {   
    
    useEffect(() => {    
      if(localStorage.getItem("appErrorDirectLink") !== null){
        consultarDispositivosAplicacion(localStorage.getItem("appErrorDirectLink"))
        localStorage.removeItem("appErrorDirectLink")
      } 
    });

    if(componentParam.appsList.length > 0){
      const listApps = componentParam.appsList.map((app) =>
        <li id={"DEV-"+app.Aplicacion} key={app.Aplicacion} className="horizontal gap-04">          
          <button className="selector icon-wrapper no-icon" >
            <div className="horizontal vertical-center gap-04 fill" onClick={() => consultarDispositivosAplicacion(app.Aplicacion)}>
              <figure className="avatar size-m"><AppLogoImg aplicacion={app.Aplicacion}/></figure>
              <div className="content">
                <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo(app.Aplicacion)}</h1>
              </div>           
            </div>            
          </button>                    
        </li> 
      );    
      return (
        <ul id="listadoAppsDispositivosInteligentes">{listApps}</ul>
      )
    }
    
  }

  return (          
    <>

      <button className="selector icon-wrapper no-icon" onClick={() => dashboardCommonJS.añadirDispositivo("MenuDispositivosConfiguracion",añadirAplicacion)}>
        <figure className="avatar size-m blue">
          <span className="material-icon">add</span>
        </figure>
        <div className="content">
          <h1>Añadir aplicación</h1>
        </div>
      </button>

      <section className="brands"> 
        <section className="brands-list">  
          <AppsList appsList={appsParam.devicesApps} />
        </section>                          
      </section>

      <Loader Id="loaderAppsConfiguradas" Mensaje="" initialStatus="contextual"/>

    </> 
  )
}

export default ListDevicesApps